import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'
import { ajaxUrls } from '../../settings/routes';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function setQuestionKey(key, data) {
  return async (dispatch) => {
    dispatch({type: "SET_QUESTION_MULTY_KEY", key, data})
  }
}

export function getQuestions(ids) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: false})
      const {data} = await axios.get('/api/question/get?ids=' + ids.join(','));

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_QUESTION_MULTYS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_QUESTION_MULTYS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getCategoriesUp(id) {
  return async (dispatch) => {
    try {

      const {data} = await axios.get('/api/category-question/get?id=' + id);

      let payload = [];

      if(data.errcode == 200) {
        const questionsCount = data.questionsCount;
        payload = data.payload.map(_i => {
          return {
            ..._i, 
            count: (questionsCount.find(_c => _c.category_id == _i.id) || {cnt: 0}).cnt
          }
        });

        dispatch({type: 'GET_QUESTION_MULTY_CATEGORIES', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function updateQuestionsOder(body) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/question/order', {
        ...body,
      });
      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_QUESTION_MULTY_ORDER', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: true})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function getCategories(id) {
  return async (dispatch) => {
    try {

      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'categories', data: []})
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'category_selcted', data: null})
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'selected', data: []})
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'list', data: []})

      const {data} = await axios.get('/api/category-question/get?id=' + id);

      let payload = [];

      if(data.errcode == 200) {
        const questionsCount = data.questionsCount;
        payload = data.payload.map(_i => {
          return {
            ..._i, 
            count: (questionsCount.find(_c => _c.category_id == _i.id) || {cnt: 0}).cnt
          }
        });



        dispatch({type: 'GET_QUESTION_MULTY_CATEGORIES', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_QUESTION_MULTY_CATEGORIES', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}


export function getCategoriesAll() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/category-question/getall');

      if(data.errcode == 200) {
        dispatch({type: 'GET_QUESTION_MULTY_CATEGORIES_ALL', data: data.payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_QUESTION_MULTY_CATEGORIES', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createQuestion(body) {
  return async (dispatch, getState) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/question/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_QUESTION_MULTY', data: payload});
        const subject_selcted = getState().question.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}

export function createQuestionCategory(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/category-question/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_QUESTION_MULTY_CATEGORY', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteQuestion(id) {
  return async (dispatch, getState) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/question/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_QUESTION_MULTY', data: id});
        dispatch(getTrashedCount());
        const subject_selcted = getState().question.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}
export function deleteQuestionCategory(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/category-question/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_QUESTION_MULTY_CATEGORY', data: id});
        dispatch(getTrashedCount());
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateQuestion(body) {
  return async (dispatch, getState) => {
    try {
      const selected_categories = getState().question.selected || [];
      
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'loaded', data: false})
      const {data} = await axios.post('/api/question/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        if(selected_categories.indexOf(body.category_id) > -1){
          dispatch({type: 'UPDATE_QUESTION_MULTY', data: payload});
        } else {
          dispatch({type: 'DELETE_QUESTION_MULTY', data: body.id});
        }
        const subject_selcted = getState().question.subject_selcted;
        if(subject_selcted && subject_selcted.id){
          dispatch(getCategoriesUp(subject_selcted.id))
        }
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}

export function getTrashedCount() {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.get('/api/question/trashedcount');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'trashed_count', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}
export function updateQuestionCategory(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/category-question/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_QUESTION_MULTY_CATEGORY', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setQuestionCategoryItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'category_selcted', data})
      return data;
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}



export function getSubjects() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/subject-question/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_QUESTION_MULTY_SUBJECTS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_QUESTION_MULTY_SUBJECTS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createQuestionSubject(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/subject-question/post', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_QUESTION_MULTY_SUBJECT', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteQuestionSubject(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/subject-question/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_QUESTION_MULTY_SUBJECT', data: id});
        dispatch(getTrashedCount());
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateQuestionSubject(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/subject-question/patch', {
        ...body,
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_QUESTION_MULTY_SUBJECT', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setQuestionSubjectItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_QUESTION_MULTY_KEY', key: 'subject_selcted', data})
      return data;
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function getRoomStudents(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/students', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_ROOM_STUDENTS', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function addRoomStudents(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/add-students', {
        room_id: body.room_id,
        ids: body.students.map(item => item.id),
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_ROOM_STUDENTS', data: body.students});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export async function sendInvite(body) {
  const {data} = await axios.post('/api/room/send-invite', body);
  if(data.errcode == 200) {
    return true
  } else {
    throw new Error('Not send');
  } 
}

export function deleteRoomStudent(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/delete-student', body);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_ROOM_STUDENT', data: body.student_id});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export async function searchStudents(body) {
  try {
    const {data} = await axios.post('/api/room/search-students', body);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}

export const uploadImage = params => {
  const { file} = params
  let data = new FormData()
  data.append('Qupload[imageFile]', file)

  return RestService.customFetch(ajaxUrls.mcq1UploadImg, RestService.customFetchHeaders, data).then(middleThen => {
    return middleThen.json();
  }).then(({errcode, message, ...response}) => {
    if (errcode !== 200) {
        throw new Error('error')
    }
    return response
  })
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/actions.js